<template>
  <ContentDetails :hub-slug="props.hubSlug" :content-slug="props.contentSlug" />
</template>

<script setup lang="ts">
import { ContentDetails } from '~/pages/_components/content-details';

definePageMeta({
  props: true,
});

const props = defineProps<{
  hubSlug: string;
  contentSlug: string;
}>();
</script>
